<template>
<transition appear name="fade">
    <div v-if="showed" id="addblock">
        <div class="container">
            <p><b><i class="fas fa-exclamation-triangle fa-fw" style="color: chocolate;"></i> Bloqueur activé !</b><br>
                Il semblerait que vous avez activé un bloqueur de publicité qui entrave le bon fonctionnement du site.
            </p>
            <button @click="showed = false" class="btn btn-primary">J'ai compris</button>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    props: [],
    mounted() {
        // document.addEventListener('DOMContentLoaded', init, false);
        this.init();
    },
    data: () => ({
        blocked: false,
        showed: false
    }),
    methods: {
        init() {
            let vm = this;
            this.adsBlocked(blocked => {

                // blocked = true; // debug

                vm.blocked = blocked;
                if (blocked) {
                    // Ads are blocked
                    // console.debug('[addblock]', 'Ads are blocked');
                    // $('.btn-facebook').on('click', () => {
                    //     vm.showed = true;
                    //
                    //     return false;
                    // });
                    // $('.btn-facebook').hide();
                } else {
                    // Ads are not blocked
                    // console.debug('[addblock]', 'Ads are not blocked');
                    // $('.btn-facebook').show();
                }
            })
        },
        adsBlocked(callback) {
            // var testURL = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
            var testURL = '//connect.fac' + 'ebook.net/en_US/fb' + 'events.js';
            var myInit = {
                method: 'HEAD',
                mode: 'no-cors'
            };
            var myRequest = new Request(testURL, myInit);
            fetch(myRequest).then(response => {
                return response;
            }).then(response => {
                // console.debug('[addblock] then', response);
                callback(false)
            }).catch(e => {
                // console.debug('[addblock] catch', e)
                callback(true)
            });
        }
    }
}
</script>
